module.exports = __webpack_public_path__ + "static/media/file-powerpoint.99444a4d.svg";